import * as components from './components'

export default [
  {
    path: '/login',
    component: components.Login,
    name: 'login',
    props: true,
    meta: {
      title: 'Pragya: Login and Get started!'
    }
  },
  {
    path: '/register',
    component: components.Register,
    name: 'register',
    props: true,
    meta: {
      title: 'Pragya: Sign up to create your Pragya Account'
    }
  },
  {
    path: '/logout',
    component: components.Logout,
    name: 'logout',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/termsAndConditions',
    component: components.TermsAndConditions,
    name: 'termsAndConditions',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/dataPrivacy',
    component: components.DataPrivacy,
    name: 'dataPrivacy',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/widget/register',
    component: components.RedirectToWeb,
    name: 'redirectToWeb',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/widget/verification',
    component: components.RedirectToWebWidgetVerification,
    name: 'redirectToWebWidgetVerification',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/verify',
    component: components.Verify,
    name: 'verify',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/learnerSignup',
    component: components.LearnerSignup,
    name: 'learnerSignup',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/institutionSignin',
    component: components.InstitutionSignin,
    name: 'institutionSignin',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/buy',
    component: components.BuyUrl,
    name: 'buyUrl',
    props: true,
    meta: {
      title: 'Pragya'
    }
  },
  {
    path: '/learnMore',
    component: components.LearnMore,
    name: 'learnMore',
    props: true,
    meta: {
      title: 'Pragya'
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/login/routes.js